import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";

import ArrowIcon from "assets/svg/project-radar/chevron.svg";

import styles from "./styles.module.css";

const Table = ({ columns, data = [], isMoreVisible = true }) => {
  const [isMore, setIsMore] = useState(false);
  const [truncatedData, setTruncatedData] = useState([]);

  const handleIsMoreClass = () => {
    setIsMore(!isMore);
  };

  useEffect(() => {
    if (isMore || !isMoreVisible) {
      setTruncatedData(data);
    } else {
      setTruncatedData(data.slice(0, 3));
    }
  }, [isMore]);

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tableHeadRow}>
            {columns.map((column, index) => (
              <th key={index} className={styles.tableHead}>
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {truncatedData.map((row, index) => (
            <tr key={index} className={styles.tableBodyRow}>
              {columns.map((column, index) => (
                <td
                  key={index}
                  className={styles.tableBodyCell}
                  style={{
                    minWidth: column.width || "auto",
                    maxWidth: column.width || "auto",
                  }}
                >
                  {column.render ? column.render(row[column.dataIndex], row) : row[column.dataIndex]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {isMoreVisible && data?.length > 3 && (
        <div className={styles.moreWrapper}>
          <div className={styles.more} onClick={handleIsMoreClass}>
            {isMore ? (
              <p className={styles.moreText}>Daha Az Gör</p>
            ) : (
              <p className={styles.moreText}>Tüm Oda Tiplerini Gör</p>
            )}
            <span
              className={classNames({
                [styles.iconTransformed]: isMore,
              })}
            >
              <ArrowIcon />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isMoreVisible: PropTypes.bool,
};

export default Table;
